import { render } from "./acctrans-review.vue?vue&type=template&id=07186957&scoped=true"
import script from "./acctrans-review.vue?vue&type=script&lang=js"
export * from "./acctrans-review.vue?vue&type=script&lang=js"

import "./acctrans-review.vue?vue&type=style&index=0&id=07186957&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07186957"]])

export default __exports__